/**
 * Document type — placeholder until the OPDOC contracts ship.
 */
export var DocumentType;
(function (DocumentType) {
    DocumentType["Pdf"] = "Pdf";
    DocumentType["Word"] = "Word";
    DocumentType["Excel"] = "Excel";
    DocumentType["PowerPoint"] = "PowerPoint";
    DocumentType["Other"] = "Other";
})(DocumentType || (DocumentType = {}));
/**
 * Template lifecycle status — mirrors OPDOC's DocumentStatus wire strings.
 */
export var DocumentStatus;
(function (DocumentStatus) {
    DocumentStatus["Draft"] = "Draft";
    DocumentStatus["Active"] = "Active";
    DocumentStatus["Archived"] = "Archived";
})(DocumentStatus || (DocumentStatus = {}));
/**
 * Template business kind — mirrors OPDOC's TemplateKind wire strings.
 * Standardized generation produces a locked PDF; Editable generation produces
 * a merged, editable copy opened in the online editor.
 */
export var TemplateKind;
(function (TemplateKind) {
    TemplateKind["Standardized"] = "Standardized";
    TemplateKind["Editable"] = "Editable";
})(TemplateKind || (TemplateKind = {}));
/**
 * Row kind — mirrors OPDOC's `DocumentKind` wire strings. Templates live in the
 * shared library; letters are personal drafts listed only for their author.
 */
export var DocumentKind;
(function (DocumentKind) {
    DocumentKind["Template"] = "Template";
    DocumentKind["Letter"] = "Letter";
})(DocumentKind || (DocumentKind = {}));
/**
 * Maps our internal DocumentType enum to the DocsAPI documentType string.
 * Falls back to "word" for unknown / "Other" — DocumentServer renders most
 * text-like formats with the word editor.
 */
export function toEditorDocumentType(type) {
    switch (type) {
        case DocumentType.Excel:
            return "cell";
        case DocumentType.PowerPoint:
            return "slide";
        case DocumentType.Pdf:
            return "pdf";
        case DocumentType.Word:
        case DocumentType.Other:
        default:
            return "word";
    }
}
